import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressRouterModule } from '@ngx-progressbar/router';
import { UserIdleModule } from 'angular-user-idle';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { environment } from '../environments/environment';
import { AppInitialize } from './app-init.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthService } from './auth/auth.service';
import { TimeoutComponent } from './auth/timeout/timeout.component';
import { ConfirmationPopupComponent } from './common-component/confirmation-popup/confirmation-popup.component';
import { FilterGridComponent } from './common-component/filter-grid/filter-grid.component';
import { ExportSelectionComponent } from './common-component/mat-table/export-selection/export-selection.component';
import { SubReportComponent } from './common-component/mat-table/sub-report/sub-report.component';
import { MultipleValidationMessageComponent } from './common-component/multiple-validation-message/multiple-validation-message.component';
import { SnackbarComponentComponent } from './common-component/snackbar-component/snackbar-component.component';
import { CommunicationService } from './common-services/communication.service';
import { HttpInterceptorService } from './common-services/http-interceptor.service';
import { IndianDateadapterService, MY_DATE_FORMATS } from './common-services/indian-dateadapter.service';
import { SnackBarService ,HistoryService} from './common-services/snack-bar.service';
import { MenuListItemComponent } from './menu/app-menu-list-item/menu-list-item.component';
import { NavService } from './menu/menu-service/nav.service';
import { MenuComponent } from './menu/menu.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { SharedModule } from './shared/shared.module';
import { SharedService } from './shared/shared.service';
import { NgxSpinnerModule } from "ngx-spinner";
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { EmailSchedulerComponentComponent } from './common-component/email-scheduler-component/email-scheduler-component.component';
import { ReportPopupComponent } from './common-component/mat-table/report-popup/report-popup.component';

export function get_settings(appInitService: AppInitialize) {
  console.log(environment.congifURL);
  return () => appInitService.getSettings(environment.congifURL);
}

@NgModule({
  declarations: [
    AppComponent,
    NotfoundComponent,
    MenuListItemComponent,
    MenuComponent,
    SnackbarComponentComponent,
    ConfirmationPopupComponent,
    TimeoutComponent,
    FilterGridComponent,
    ExportSelectionComponent,
    SubReportComponent,
    MultipleValidationMessageComponent,
    EmailSchedulerComponentComponent,
    ReportPopupComponent, /*~~~~~~~~~~~~~ Tushar 2024-12-09 Gid.:198*/
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    NgProgressModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgProgressRouterModule,
    KeyboardShortcutsModule,
    UserIdleModule.forRoot({ idle: 150, timeout: 60, ping: 120 }),
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    NgxSpinnerModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [NavService, AppInitialize, AuthGuard, AuthService, SnackBarService, SharedService,HistoryService,CommunicationService,
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    { provide: APP_INITIALIZER, useFactory: get_settings, deps: [AppInitialize], multi: true },
    { provide: DateAdapter, useClass: IndianDateadapterService },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
  entryComponents: [MultipleValidationMessageComponent, SnackbarComponentComponent, ConfirmationPopupComponent, TimeoutComponent, FilterGridComponent, ExportSelectionComponent,SubReportComponent,EmailSchedulerComponentComponent,ReportPopupComponent,],
  bootstrap: [AppComponent]
})
export class AppModule { }
